export default __webpack_public_path__ + "static/media/productsBanner.a8d9a65b.jpg";